// Team-specific cache management utility

export function clearTeamSpecificCaches() {
  // Clear localStorage team-dependent data
  const teamSpecificKeys = [
    'projects_cache',
    'analyses_cache', 
    'team_stats_cache',
    'team_members_cache',
    'research_pipelines_cache',
    'credit_usage_cache',
    'billing_cache'
  ];

  teamSpecificKeys.forEach(key => {
    localStorage.removeItem(key);
  });

  // Clear sessionStorage data
  const sessionKeys = [
    'current_project',
    'current_analysis',
    'current_meeting',
    'dashboard_cache',
    'navigation_state'
  ];

  sessionKeys.forEach(key => {
    sessionStorage.removeItem(key);
  });

  // Clear any other team-specific cached data with patterns
  const allLocalKeys = Object.keys(localStorage);
  allLocalKeys.forEach(key => {
    if (key.includes('team_') || 
        key.includes('project_') || 
        key.includes('analysis_') ||
        key.includes('meeting_') ||
        key.includes('pipeline_') ||
        key.includes('credit_')) {
      localStorage.removeItem(key);
    }
  });

  const allSessionKeys = Object.keys(sessionStorage);
  allSessionKeys.forEach(key => {
    if (key.includes('team_') || 
        key.includes('project_') || 
        key.includes('analysis_') ||
        key.includes('meeting_') ||
        key.includes('pipeline_') ||
        key.includes('credit_')) {
      sessionStorage.removeItem(key);
    }
  });

  // Team-specific caches cleared
}

export function clearSpecificCache(cacheType) {
  switch (cacheType) {
    case 'projects':
      localStorage.removeItem('projects_cache');
      localStorage.removeItem('current_project');
      sessionStorage.removeItem('current_project');
      break;
    
    case 'analyses':
      localStorage.removeItem('analyses_cache');
      sessionStorage.removeItem('current_analysis');
      break;
    
    case 'teams':
      localStorage.removeItem('team_stats_cache');
      localStorage.removeItem('team_members_cache');
      break;
    
    case 'credits':
      localStorage.removeItem('credit_usage_cache');
      localStorage.removeItem('billing_cache');
      break;
    
    case 'research':
      localStorage.removeItem('research_pipelines_cache');
      break;
    
    default:
      console.warn(`Unknown cache type: ${cacheType}`);
  }
}

export function getCacheKeys() {
  return {
    localStorage: Object.keys(localStorage).filter(key => 
      key.includes('team_') || 
      key.includes('project_') || 
      key.includes('analysis_') ||
      key.includes('cache')
    ),
    sessionStorage: Object.keys(sessionStorage).filter(key => 
      key.includes('team_') || 
      key.includes('project_') || 
      key.includes('analysis_') ||
      key.includes('current_')
    )
  };
}